document.addEventListener("DOMContentLoaded", () => {
    const galleries = document.querySelectorAll('[id^="GalleryViewer-"]');
    galleries.forEach(gallery => {
        const slides = gallery?.querySelectorAll(".slider__slide");
        const currentEl = document.querySelector(".media-counter .current-slide");
        const totalEl = document.querySelector(".media-counter .total-slide");
        const progressBar = document.querySelector(".media-progress-bar .progress-fill");
        const nextBtn = document.querySelector(".slider-button--next");
        const prevBtn = document.querySelector(".slider-button--prev");

        if (!gallery || !slides || slides.length === 0) return;

        let currentIndex = 1;
        const total = slides.length;
        totalEl.textContent = total;

        const updateUI = (index) => {
            currentEl.textContent = index;
            progressBar.style.width = `${(index / total) * 100}%`;
        };

        const scrollThumbnailSafely = (thumbnailIndex) => {
            const thumbnails = document.querySelectorAll(".thumbnail");
            const targetThumbnail = thumbnails[thumbnailIndex];

            if (!targetThumbnail) return;

            const thumbnailContainer = targetThumbnail.closest('.thumbnail-container, .thumbnail-list, .slider-nav')
                || targetThumbnail.parentElement;

            if (thumbnailContainer) {
                const containerRect = thumbnailContainer.getBoundingClientRect();
                const thumbnailRect = targetThumbnail.getBoundingClientRect();

                const scrollLeft = thumbnailContainer.scrollLeft +
                    (thumbnailRect.left - containerRect.left) -
                    (containerRect.width / 2) + (thumbnailRect.width / 2);

                thumbnailContainer.scrollTo({
                    left: scrollLeft,
                    behavior: "smooth"
                });
            }
        };

        const updateThumbnailState = (index) => {
            const thumbnails = document.querySelectorAll(".thumbnail");
            thumbnails.forEach((thumb) => thumb.removeAttribute("aria-current"));
            if (thumbnails[index - 1]) {
                thumbnails[index - 1].setAttribute("aria-current", "true");
            }
        };

        const observer = new MutationObserver(() => {
            slides.forEach((slide, idx) => {
                if (slide.classList.contains("is-active")) {
                    currentIndex = idx + 1;
                    updateUI(currentIndex);
                }
            });
        });

        observer.observe(gallery, {
            attributes: true,
            subtree: true,
            attributeFilter: ["class"]
        });

        updateUI(currentIndex);

        progressBar.addEventListener("animationiteration", () => {
            let nextIndex = (currentIndex % total) + 1;
            slides.forEach((slide) => slide.classList.remove("is-active"));
            slides[nextIndex - 1].classList.add("is-active");
            updateThumbnailState(nextIndex);
            scrollThumbnailSafely(nextIndex - 1);
            updateUI(nextIndex);
            currentIndex = nextIndex;
        });

        function updateGallery(index, shouldScrollThumbnail = true) {
            slides.forEach((slide) => slide.classList.remove("is-active"));
            slides[index - 1].classList.add("is-active");
            updateThumbnailState(index);
            if (shouldScrollThumbnail) {
                scrollThumbnailSafely(index - 1);
            }
            updateUI(index);
            currentIndex = index;
        }

        if (nextBtn) {
            nextBtn.addEventListener("click", () => {
                let nextIndex = (currentIndex % total) + 1;
                updateGallery(nextIndex, true); // User action -> có thể scroll
                // Reset progressBar animation
                progressBar.style.animation = "none";
                progressBar.offsetHeight;
                progressBar.style.animation = "";
            });
        }

        if (prevBtn) {
            prevBtn.addEventListener("click", () => {
                let prevIndex = ((currentIndex - 2 + total) % total) + 1;
                updateGallery(prevIndex, true);
                progressBar.style.animation = "none";
                progressBar.offsetHeight;
                progressBar.style.animation = "";
            });
        }
    });
});